import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'payment-campaign',
    name: 'crm.payment-campaign',
    meta: {
      title: 'Payment Campaign',
      action: 'read',
      subject: CASL.ACCESS.PAYMENT_CAMPAIGN
    },
    component: () => import('./list/PaymentCampaignListPage.vue')
  },
  {
    path: 'payment-campaign/add',
    name: 'crm.payment-campaign.add',
    meta: {
      title: 'Payment Campaign Add',
      action: 'create',
      subject: CASL.ACCESS.PAYMENT_CAMPAIGN
    },
    component: () => import('./form/PaymentCampaignFormPage.vue')
  },
  {
    path: 'payment-campaign/:uuid',
    name: 'crm.payment-campaign.detail',
    meta: {
      title: 'Payment Campaign Detail',
      action: 'read',
      subject: CASL.ACCESS.PAYMENT_CAMPAIGN
    },
    component: () => import('./detail/PaymentCampaignDetailPage.vue')
  },
  {
    path: 'payment-campaign/:uuid/edit',
    name: 'crm.payment-campaign.edit',
    meta: {
      title: 'Payment Campaign Edit',
      action: 'update',
      subject: CASL.ACCESS.PAYMENT_CAMPAIGN
    },
    component: () => import('./form/PaymentCampaignFormPage.vue')
  }
]
